export class ClaimPermissions {
    static read: string = 'claimsmanager:read:claim';
    static search: string = 'claimsmanager:search:claim';
    static write: string = 'claimsmanager:write:claim';
    static finalise: string = 'claimsmanager:finalise:claim';
    static close: string = 'claimsmanager:close:claim';
    static assess: string = 'claimsmanager:assess:claim';
    static reopen: string = 'claimsmanager:reopen:claim';
}
